export default __webpack_public_path__ + "static/media/smartphone.7447f05f.png";